/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';
import passwordChangeForm from '../views/password-change/FormPasswordChange.vue';
import { setBreadcrumb } from './index';

const passwordChange = {
  path: '/password-change',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Change Password',
        appBarTitle: 'Change Password',
        breadcrumbs: () => [
          setBreadcrumb('Change Password', '/password-change', true),
          setBreadcrumb('Form Change Password', '/password-change'),
        ],
      },
      component: passwordChangeForm,
      name: 'passwordChangeForm',
    },
  ],

  meta: {
    title: 'BNI QRIS - Report EDC',
    appBarTitle: 'Report EDC',
  },
  component: Parent,
};

export default passwordChange;
